module.exports = __webpack_public_path__ + "static/media/ic-checklist.223e528f.svg";